import React from "react";
import { Hero, About, Skills, Projects } from "../components";

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Skills />
      <Projects />
    </>
  );
}

export default HomePage;
